import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import { ArmyListView } from '@Selectors/builder/myBuilder/show/view/ArmyListView';

interface IArmyListComponentProps {
  armyList: ArmyListView
}

const SearchArmyListComponent: React.FC<ArmyListComponentProps> = ({armyList}) => {
  const currentLocale = document.documentElement.lang;
  return (
    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 army_list_row text-center">
      <a href={`/${currentLocale}/builder/army_lists/${armyList.id}/export-full-magics-page.html`}>
        {armyList.logo !== null && <img className="img-fluid w-100" alt={armyList.name || ''} src={armyList.logo} />}
        <h4 className="boxtitre">{(armyList.name || '').substring(0, 60)}</h4>
      </a>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListComponentProps) => ({
  armyList: owsProps.armyList
})

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SearchArmyListComponent);

type ArmyListComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
